<div class="container-fluid">
  <div class="row p-4" *ngIf="!fromOtherComp">
    <div class="col">
      <app-fast-search [appearFastSearch]="false" [appCodes]="[8111,169]" (toggle)="false"
        (searchKeys)="onSearchClick($event)"></app-fast-search>
    </div>
  </div>

  <div class="row" *ngIf="showApprovalUsers">
    <div class="col">
      <alert-approve-cycle-trance [hideSavebtn]="true"></alert-approve-cycle-trance>
    </div>
  </div>


</div>

<div>
  <block-modal-container #popup>
    <ng-container class="modal-body"></ng-container>
  </block-modal-container>
</div>